import './GifSapo.css'

const GifSapo = () => {
    return (
        <>
            <div className="gifSapoctor">
                <img src="/images/sapo.gif" alt="Sapo Doctor" />
            </div>
        </>
    );
};

export default GifSapo;